<div class="m-1">
    @if (AdaaHelper.isDefinedAndNotEmpty(label())) {
        <label [for]="effectiveControlId()" class="form-label fw-bold" [dir]="languageService.direction()">
            {{ label() }}
            @if (isRequired()) {
                <span class="form-required text-danger fw-bolder">*</span>
            }
        </label>
    }

    <input
        id="time"
        type="time"
        min="00:00"
        max="23:59"
        class="form-control"
        aria-describedby="time"
        pattern="[0-9]{2}:[0-9]{2}"
        [class.is-invalid]="invalid()"
        [disabled]="effectivelyDisabled()"
        (ngModelChange)="valueChanged($event)"
        [ngModel]="time()"
    />
</div>
